import { Button, ExportIcon, Tooltip } from "@saleor/macaw-ui-next";
import React, { forwardRef, useState } from "react";

interface BulkExportButtonProps {
  onClick: () => void;
  disabled?: boolean;
  children: React.ReactNode;
}

export const BulkExportButton = forwardRef<
  HTMLButtonElement,
  BulkExportButtonProps
>(({ onClick, children, disabled }, ref) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  return (
    <Tooltip open={isTooltipOpen}>
      <Tooltip.Trigger>
        <Button
          ref={ref}
          disabled={disabled}
          onMouseOver={() => {
            setIsTooltipOpen(true);
          }}
          onMouseLeave={() => {
            setIsTooltipOpen(false);
          }}
          onClick={onClick}
          icon={<ExportIcon />}
          variant="secondary"
          data-test-id="bulk-export-button"
        />
      </Tooltip.Trigger>
      <Tooltip.Content side="bottom">
        <Tooltip.Arrow />
        {children}
      </Tooltip.Content>
    </Tooltip>
  );
});

BulkExportButton.displayName = "BulkExportButton";
